
<template>
  <el-container>
    <el-header>
      <el-menu
        mode="horizontal"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
        router
      >
        <el-menu-item index="/dashboard">首页</el-menu-item>
        <el-menu-item 
          v-if="role === 'ADMIN'"
          index="/AdminApproval"
        >
          用户管理
        </el-menu-item>
        <el-menu-item index="/customers">客户管理</el-menu-item>
        <el-menu-item index="/projects">订单管理</el-menu-item>
        <el-menu-item index="/messages">
          <el-badge :value="unreadCount" :max="99" class ="item">
            <i class="iconfont icon-notify">&#xe679</i>
            <!-- 站内消息 -->
          </el-badge>
        </el-menu-item>
        <el-sub-menu index="user" v-if="user!=null" class="user-menu">
          <template #title>{{ user.username }}</template>
          <el-menu-item index="/userInfo"><span slot="title">个人设置</span></el-menu-item>
          <el-menu-item @click="handleLogout">退出登录</el-menu-item>
        </el-sub-menu>
      </el-menu>
    </el-header>
    <el-main>
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
import { computed, ref, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  name: 'App',
  setup() {
    const store = useStore()
    const router = useRouter()

    const user = computed(() => store.state.user)
    const role = computed(() => store.state.role)
    const unreadCount = computed(() => store.state.unreadCount)
    const receiverId = ref(null)

    const handleLogout = () => {
      store.dispatch('logout')
      router.push('/login')
    }

    // 获取未读消息数
    const fetchUnreadCount = async () => {
      if (user.value && user.value.id) {
        store.dispatch('getUnreadCountMessage')
          .then(res => {
            console.log('unreadCount', res)
          })
          .catch(error => {
            console.error('获取未读消息数失败:', error)
          })
        }
      }

  

    // 监听user变化，确保用户登录后能获取未读消息数
    watch(user, (newUser) => {
      if (newUser && newUser.id) {
        receiverId.value = newUser.id
        fetchUnreadCount()
      }
    }, { immediate: true })

    // 组件挂载时设置定时器定期刷新未读消息数
    onMounted(() => {
      const interval = setInterval(fetchUnreadCount, 60000) // 每分钟刷新一次
      return () => clearInterval(interval) // 清理定时器
    })

    return {
      user,
      role,
      handleLogout,
      unreadCount
    }
  }
}
</script>

<style>
.el-header {
  padding: 0;
}
.user-menu {
  float: right;
}
.el-menu-item .el-badge .el-badge__content {
    position: absolute !important;
    right: 25px !important;
    top: 20px !important;
    transform: translateY(-50%) translateX(100%) !important;
    z-index: 1000 !important;
}
</style>
